"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsLineupMember } from "fansunited-data-layer";
import { getLabel } from "@/lib/labels/getLabel";
import type { Labels } from "@/lib/labels/types";
import { LineupsPlayerRow } from "./LineupsPlayerRow";
import type { PlayerEventsMap } from "./playerEventsHelper";
interface TeamLineupProps {
  starters: FUSportsLineupMember[];
  substitutes: FUSportsLineupMember[];
  isHome: boolean;
  labels: Labels;
  playerEventsMap?: PlayerEventsMap;
}

/**
 * Group players by position line (row)
 */
function groupByPosition(players: FUSportsLineupMember[]): FUSportsLineupMember[][] {
  const sorted = [...players].sort((a, b) => (a.positionY || 0) - (b.positionY || 0));
  const groups: FUSportsLineupMember[][] = [];
  let currentY = -1;
  let currentGroup: FUSportsLineupMember[] = [];
  sorted.forEach(player => {
    if (player.positionY !== currentY) {
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [player];
      currentY = player.positionY || 0;
    } else {
      currentGroup.push(player);
    }
  });
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }
  return groups;
}

/**
 * Team lineup column component
 * Displays starting XI grouped by position and substitutes
 */
export const TeamLineup: React.FC<TeamLineupProps> = t0 => {
  const $ = _c(21);
  const {
    starters,
    substitutes,
    isHome,
    labels,
    playerEventsMap
  } = t0;
  let t1;
  let t2;
  if ($[0] !== isHome || $[1] !== labels || $[2] !== playerEventsMap || $[3] !== starters) {
    const positionGroups = groupByPosition(starters);
    t2 = "flex-1 px-3 py-2";
    let t3;
    if ($[6] !== isHome || $[7] !== labels || $[8] !== playerEventsMap) {
      t3 = (group, idx) => <div key={idx}>{group.map(player => <LineupsPlayerRow key={player.id} player={player} isHome={isHome} labels={labels} playerEvents={playerEventsMap?.get(player.id)} />)}</div>;
      $[6] = isHome;
      $[7] = labels;
      $[8] = playerEventsMap;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t1 = positionGroups.map(t3);
    $[0] = isHome;
    $[1] = labels;
    $[2] = playerEventsMap;
    $[3] = starters;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t1) {
    t3 = <div>{t1}</div>;
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isHome || $[13] !== labels || $[14] !== playerEventsMap || $[15] !== substitutes) {
    t4 = substitutes.length > 0 && <><div className={`text-xs font-bold text-muted-foreground uppercase mt-4 mb-2 ${isHome ? "" : "text-right"}`}>{getLabel(labels, "matchPage.lineups.substitutes")}</div><div>{substitutes.map((player_0, index) => <LineupsPlayerRow key={player_0.id} player={player_0} isHome={isHome} labels={labels} playerEvents={playerEventsMap?.get(player_0.id)} isLast={index === substitutes.length - 1} />)}</div></>;
    $[12] = isHome;
    $[13] = labels;
    $[14] = playerEventsMap;
    $[15] = substitutes;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};